import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import verticalLink from 'lib/verticalLink';

import VerticalLogo, { THEME as LOGO_THEME } from 'components/logos/Vertical';
import { GlobalCitizenLogo } from 'components/logos/GlobalCitizen';
import MSNBCLogo from 'components/logos/MSNBC';
import NewsLogo from 'components/logos/News';
import { NoticiasLogo } from 'components/logos/Noticias';
import { SelectLogo } from 'components/logos/Select';
import TodayLogo from 'components/logos/Today';

import { loadNavigation as loadNavigationAction } from 'redux/modules/layout';

/**
 *
 * @param {object} props
 * @param {object} props.shared
 * @param {object} props.layout
 */
const mapStateToProps = ({
  shared,
  layout,
}) => ({
  vertical: shared.vertical,
  navigation: layout.navigation,
});

/**
 *
 * @param {Function} dispatch
 */
const mapActionsToProps = (dispatch) => ({
  /**
   *
   * @param {string} vertical
   */
  loadNavigation: (vertical) => dispatch(loadNavigationAction(vertical)),
});

/**
 *
 * @param {object} props
 * @param {string} props.vertical
 * @param {Function} props.loadNavigation
 * @param {object} props.navigation
 */
function Fallback({
  vertical,
  loadNavigation,
  navigation = {},
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    loadNavigation(vertical);
  }, [loadNavigation, vertical]);

  /**
   *
   */
  const logo = () => {
    switch (vertical) {
      case 'news':
        return <NewsLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
      case 'noticias':
        return <NoticiasLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
      case 'today':
        return <TodayLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
      case 'msnbc':
        return <MSNBCLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
      case 'globalcitizen':
        return <GlobalCitizenLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
      case 'select':
        return <SelectLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
      default:
        return <VerticalLogo vertical={vertical} color={LOGO_THEME.LIGHT} />;
    }
  };

  // Format of the url property differs between APIs
  /**
   *
   * @param {object|string} link
   */
  const url = (link) => link.primary || link;

  /**
   *
   */
  const global = () => {
    const items = navigation.global || [];
    if (!items.length) return null;
    return (
      <div className="bg-black ph5">
        <ul className="df items-center pv4">
          {items.map((item) => (
            <li key={item.text} className="o-60 mr5">
              <a href={url(item.url)}>
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  /**
   *
   */
  const local = () => {
    const items = navigation.local || [];
    if (!items.length) return null;
    return (
      <div className="flex-1 mh-auto dn db-m">
        <ul className="db tc h-100 overflow-y-hidden">
          {items.map((item) => (
            <li key={item.text} className="dib mr7">
              <a href={url(item.url)}>
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div
      ref={containerRef}
      className="layout-header__default founders-cond f5 ttu white"
      data-testid="service-header__default"
    >
      {global()}
      <nav className="layout-header__default-navbar df relative z-1">
        <div className="layout-header__default-logo flex-grow-0 df relative">
          <a href={`/${verticalLink(vertical)}`}>
            {logo()}
          </a>
        </div>
        {local()}
      </nav>
    </div>
  );
}

export const HeaderFallback = connect(mapStateToProps, mapActionsToProps)(Fallback);
